<script setup lang="ts">
    import Burger from '@/components/Burger.ce.vue';
    import { getContrastColor } from '@/helpers/text';
    import NavigationButton from '@shared/components/navigation/navigation-button.vue';

    const props = defineProps<{
        brandColor?: string
        inAppointment?: boolean
        inContact?: boolean
        inCall?: boolean
    }>();

    const emit = defineEmits<{(event: 'contactSelected' | 'callSelected' | 'appointmentSelected')}>();

    const { navigationButtons } = storeToRefs(useWidgetMenuStore());

    const isButtonActive = computed(() => (key: string) =>
        Boolean({
            appointment: props.inAppointment,
            contact: props.inContact,
            call: props.inCall,
        }[key] ?? false));
</script>

<template>
    <div class="side-bar">
        <div class="side-bar__top">
            <Burger
                :brand-color="brandColor"
                is-ghost
            />
        </div>
        <div class="side-bar__bottom">
            <template
                v-for="btn in navigationButtons"
                :key="btn.key"
            >
                <NavigationButton
                    v-if="btn.activated"
                    :page-name="btn.pageName"
                    :style="{ color: getContrastColor(brandColor ?? '#282829')}"
                    :is-active="isButtonActive(btn.key)"
                    :main-icon="btn.mainIcon"
                    :secondary-icon="btn.secondaryIcon"
                    tooltip-direction="right"
                    icon-size="medium"
                    class="side-bar__bottom__nav-btn"
                    is-button
                    @click="emit(btn.event as 'contactSelected' | 'callSelected' | 'appointmentSelected')"
                />
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .side-bar {
        z-index: var(--zindex-overlay);
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background: var(--widget-brand-color);
        block-size: 100%;
        border-inline-start: 1px solid var(--border-secondary);
        inline-size: var(--size-12);
        padding-block: var(--spacing-03) var(--spacing-04);

        &__top,
        &__bottom {
            display: flex;
            inline-size: 100%;
        }

        &__top {
            justify-content: center;
        }

        &__bottom {
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            gap: var(--spacing-03);
        }

        @include min-width(lg) {
            display: flex;
        }
    }
</style>
